"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_WITHDRAW_ERROR_MESSAGES = exports.EAllWithdrawErrors = exports.PARAMS_KEYS_FOR_ACCOUNT_KEY = exports.METHODS_FOR_MAPPING_FIELDS = exports.PAYMENT_METHODS = exports.REG_PHONE_NUMBER = exports.PAYMENT_QUERY_PARAM = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
/* eslint-disable no-useless-escape */
exports.PAYMENT_QUERY_PARAM = 'payment';
exports.REG_PHONE_NUMBER = /^((8|\+374|\+994|\+995|\+375|\+7|\+380|\+38|\+996|\+998|\+993)[\- ]?)?\(?\d{3,5}\)?[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}(([\- ]?\d{1})?[\- ]?\d{1})?$/;
var PAYMENT_METHODS;
(function (PAYMENT_METHODS) {
    PAYMENT_METHODS["CARD"] = "card";
    PAYMENT_METHODS["WEB_MONEY"] = "webMoney";
    PAYMENT_METHODS["MOBILE_PHONE"] = "phone";
    PAYMENT_METHODS["EMAIL"] = "email";
    PAYMENT_METHODS["CRYPTOCURRENCY"] = "cryptocurrency";
})(PAYMENT_METHODS || (exports.PAYMENT_METHODS = PAYMENT_METHODS = {}));
exports.METHODS_FOR_MAPPING_FIELDS = {
    [betweb_openapi_axios_1.MethodParameterType.AccountNumber]: PAYMENT_METHODS.WEB_MONEY,
    [betweb_openapi_axios_1.MethodParameterType.Email]: PAYMENT_METHODS.EMAIL,
    [betweb_openapi_axios_1.MethodParameterType.PhoneNumber]: PAYMENT_METHODS.MOBILE_PHONE,
    [betweb_openapi_axios_1.MethodParameterType.CardNumber]: PAYMENT_METHODS.CARD,
    [betweb_openapi_axios_1.MethodParameterType.String]: PAYMENT_METHODS.CRYPTOCURRENCY,
};
exports.PARAMS_KEYS_FOR_ACCOUNT_KEY = {
    [betweb_openapi_axios_1.MethodParameterType.AccountKey]: 'key',
};
var EAllWithdrawErrors;
(function (EAllWithdrawErrors) {
    EAllWithdrawErrors["SMS_SENDING_ERROR"] = "SMS_SENDING_ERROR";
    EAllWithdrawErrors["INCORRECT_VALIDATION_CODE"] = "INCORRECT_VALIDATION_CODE";
})(EAllWithdrawErrors || (exports.EAllWithdrawErrors = EAllWithdrawErrors = {}));
exports.ALL_WITHDRAW_ERROR_MESSAGES = {
    [EAllWithdrawErrors.SMS_SENDING_ERROR]: 'unable to send sms',
    [EAllWithdrawErrors.INCORRECT_VALIDATION_CODE]: 'unable to send sms',
};
//# sourceMappingURL=constants.js.map